"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
require("./Table.scss");
const react_intl_1 = require("react-intl");
const defaultProps = {
    rowClassName: () => 'element-table-row',
};
// Default section renderer that expects label to be an i18n message id
const defaultSectionRenderer = (record, columns) => ((0, jsx_runtime_1.jsx)("td", { colSpan: columns.length, style: { padding: '0.5rem 1.2rem' }, children: record.label && typeof record.label === 'string' ? (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: record.label }) : record.label }));
function TableComponent(props) {
    const { enableSections, sectionRenderer, components, columns = [], ...restProps } = props;
    // Only add section handling if enableSections is true
    const tableComponents = enableSections
        ? {
            ...components,
            body: {
                ...components === null || components === void 0 ? void 0 : components.body,
                row: ({ children, ...rowProps }) => {
                    var _a, _b;
                    const record = (_b = (_a = children === null || children === void 0 ? void 0 : children[0]) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.record;
                    if (record === null || record === void 0 ? void 0 : record.isSectionTitle) {
                        return ((0, jsx_runtime_1.jsx)("tr", { ...rowProps, className: "section-title-row", children: sectionRenderer
                                ? sectionRenderer(record)
                                : defaultSectionRenderer(record, columns) }));
                    }
                    return (0, jsx_runtime_1.jsx)("tr", { ...rowProps, children: children });
                },
            },
        }
        : components;
    return (0, jsx_runtime_1.jsx)(antd_1.Table, { ...defaultProps, ...restProps, columns: columns, components: tableComponents });
}
TableComponent.Summary = antd_1.Table.Summary;
exports.default = TableComponent;
